import { useEffect } from "react";

export const useAbortController = () => {
    const controller = new AbortController();

    useEffect(() => {
        
        return () => {
            controller.abort();
        }
    }, [])

    return {controller}
}